const NoInspectionState = () => (
  <div className="noInspectionState">
    <div className="nisIconWrap">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect
          x="8"
          y="6"
          width="32"
          height="36"
          rx="4"
          stroke="currentColor"
          strokeWidth="2.2"
        />
        <path
          d="M16 16h16M16 22h16M16 28h10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="36" cy="36" r="8" fill="var(--bdk)" />
        <path
          d="M32 36h8M36 32v8"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
    <div className="nisTitle">No Inspection Assigned</div>
    <div className="nisSub">
      You have no active inspection assignments at this time. New projects will
      appear here once assigned by your administrator.
    </div>
  </div>
);

export default NoInspectionState;
